export const categoriesOrder = ['necessary', 'functional', 'analytics', 'marketing'];
export const services = [
    {
        id: 'authorization',
        elements: ['useAuthStore', 'user-storage', 'useAuthFormStore', 'auth-form-storage'],
        category: 'necessary',
        retention: 'until-logout',
        descriptions: {
            pl: {
                name: 'Logowanie i autoryzacja',
                description: 'Przechowuje dane zalogowanego użytkownika (identyfikator, e-mail, imię) oraz token dostępu, a także stan formularza logowania (wpisany e-mail, licznik ponownego wysłania kodu). Niezbędne do korzystania z konta.',
                retention: 'do wylogowania',
            },
            en: {
                name: 'Sign-in and authorization',
                description: "Stores the signed-in user's profile (id, email, name) and access token, plus login-form state (entered email, resend-cooldown timer). Required to use a user account.",
                retention: 'until sign-out',
            },
        },
    },
    {
        id: 'parkingReservation',
        elements: ['useReservationStore', 'reservation-storage'],
        category: 'necessary',
        retention: '5-minutes',
        descriptions: {
            pl: {
                name: 'Rezerwacja parkingu',
                description: 'Przechowuje wybrany parking, pojazd i czas parkowania w trakcie tworzenia rezerwacji. Dane wygasają po 5 minutach od ostatniej aktywności.',
                retention: '5 minut od ostatniej aktywności',
            },
            en: {
                name: 'Parking reservation',
                description: 'Stores the selected parking, vehicle and park duration while a reservation is being created. Expires 5 minutes after the last activity.',
                retention: '5 minutes after last activity',
            },
        },
    },
    {
        id: 'googleMaps',
        elements: ['@vis.gl/react-google-maps', 'google.maps JS API'],
        category: 'functional',
        retention: 'third-party',
        descriptions: {
            pl: {
                name: 'Mapa Google',
                description: 'Interaktywna mapa parkingów renderowana jest przez Google Maps. Przeglądarka łączy się z serwerami Google, które mogą zapisywać własne pliki cookie w swoich domenach oraz otrzymują adres IP i współrzędne oglądanego obszaru. Mapa jest niezbędna do wyboru parkingu, więc nie można jej wyłączyć.',
                retention: 'nie przechowujemy danych lokalnie; retencja po stronie Google zgodnie z polityką prywatności Google',
            },
            en: {
                name: 'Google Maps',
                description: "The interactive parking map is rendered by Google Maps. Your browser connects to Google's servers, which may set their own cookies on google.com domains and receive your IP address and the coordinates of the area being viewed. The map is required to pick a parking, so it cannot be disabled.",
                retention: "not stored locally; Google-side retention follows Google's privacy policy",
            },
        },
    },
    {
        id: 'chunkRefresh',
        elements: ['chunk_refresh_attempted'],
        category: 'necessary',
        retention: 'session',
        descriptions: {
            pl: {
                name: 'Odświeżanie po wdrożeniu nowej wersji',
                description: 'Po wdrożeniu nowej wersji aplikacji starsze pliki mogą być niedostępne. Ta flaga sesyjna pozwala odświeżyć stronę dokładnie raz, aby pobrać aktualne pliki i uniknąć pętli odświeżania.',
                retention: 'do pierwszego udanego załadowania strony',
            },
            en: {
                name: 'Post-deployment refresh',
                description: 'After a new deployment, older chunk files may be unavailable. This session flag lets the page refresh exactly once to fetch up-to-date files and prevents a refresh loop.',
                retention: 'until the first successful page load',
            },
        },
    },
    {
        id: 'language',
        elements: ['useLanguageStore', 'language-storage'],
        category: 'necessary',
        retention: 'indefinite',
        descriptions: {
            pl: {
                name: 'Preferowany język interfejsu',
                description: 'Zapamiętuje wybrany język aplikacji (np. polski lub angielski), abyś nie musiał ustawiać go ponownie przy kolejnych wizytach.',
                retention: 'bez terminu (do zmiany przez użytkownika lub wyczyszczenia danych przeglądarki)',
            },
            en: {
                name: 'Preferred interface language',
                description: "Remembers which language you chose (e.g. Polish or English) so you don't have to set it again on future visits.",
                retention: 'indefinite (until you change it or clear browser data)',
            },
        },
    },
    {
        id: 'parkingSearch',
        elements: ['useParkingSearchStore', 'parking-search-storage'],
        category: 'necessary',
        retention: 'indefinite',
        descriptions: {
            pl: {
                name: 'Preferencje wyszukiwania parkingów',
                description: 'Zapamiętuje Twoje filtry, sposób sortowania, ostatnio wybrane miasto, wpisany adres oraz aktualny widok mapy, abyś wracając do aplikacji widział te same wyniki wyszukiwania.',
                retention: 'bez terminu (do wyczyszczenia danych przeglądarki)',
            },
            en: {
                name: 'Parking search preferences',
                description: 'Remembers your filters, sort order, last selected city, entered address and current map viewport so your search results match when you come back.',
                retention: 'indefinite (until you clear browser data)',
            },
        },
    },
    {
        id: 'splashScreenHider',
        elements: ['parkapp_splash_screen_shown'],
        category: 'necessary',
        retention: 'session',
        descriptions: {
            pl: {
                name: 'Ukrywanie ekranu powitalnego',
                description: 'Zapamiętuje w obrębie jednej sesji przeglądarki, że animacja powitalna została już wyświetlona, aby nie pojawiała się ponownie przy odświeżaniu strony.',
                retention: 'do zamknięcia karty przeglądarki',
            },
            en: {
                name: 'Splash-screen suppression',
                description: "Records within a single browser session that the welcome animation has already been played so it isn't shown again on reload.",
                retention: 'until the browser tab is closed',
            },
        },
    },
    {
        id: 'theme',
        elements: ['theme'],
        category: 'functional',
        retention: 'indefinite',
        descriptions: {
            pl: {
                name: 'Motyw (jasny / ciemny)',
                description: 'Zapamiętuje wybrany motyw kolorystyczny interfejsu.',
                retention: 'bez terminu (do zmiany przez użytkownika lub wyczyszczenia danych przeglądarki)',
            },
            en: {
                name: 'Color theme (light / dark)',
                description: 'Remembers your chosen UI color theme.',
                retention: 'indefinite (until you change it or clear browser data)',
            },
        },
    },
    {
        id: 'parkingCreate',
        elements: ['useParkingCreateStore', 'createParking-storage'],
        category: 'functional',
        retention: 'indefinite',
        descriptions: {
            pl: {
                name: 'Formularz dodawania parkingu',
                description: 'Przechowuje częściowo wypełniony formularz tworzenia parkingu (adres, miejsca), aby umożliwić wznowienie pracy po zamknięciu karty.',
                retention: 'bez terminu (do zapisania parkingu lub wyczyszczenia danych przeglądarki)',
            },
            en: {
                name: 'Parking creation form',
                description: 'Preserves a partially filled-in parking creation form (address, spots) so you can resume after closing the tab.',
                retention: 'indefinite (until the parking is saved or browser data is cleared)',
            },
        },
    },
    {
        id: 'locationPermission',
        elements: ['locationPermissionDismissed'],
        category: 'necessary',
        retention: '1-day',
        descriptions: {
            pl: {
                name: 'Prośba o dostęp do lokalizacji',
                description: 'Jeśli odrzucisz prośbę o udostępnienie Twojej bieżącej lokalizacji, zapisujemy dzisiejszą datę, aby nie prosić Cię ponownie tego samego dnia.',
                retention: '1 dzień (do najbliższej północy)',
            },
            en: {
                name: 'Location-access prompt',
                description: "If you dismiss the location-access prompt, today's date is stored so we don't ask again on the same day.",
                retention: '1 day (until midnight)',
            },
        },
    },
    {
        id: 'googleReverseGeocode',
        elements: ['Google Geocoding API (fetch)'],
        category: 'functional',
        retention: 'third-party',
        descriptions: {
            pl: {
                name: 'Geokodowanie odwrotne Google',
                description: 'Gdy wskazujesz punkt na mapie lub wyszukujesz miasto, współrzędne geograficzne są wysyłane do API geokodowania Google w celu zamiany ich na adres pocztowy. Wynik nie jest zapisywany lokalnie na stałe.',
                retention: 'nie zapisywane lokalnie; retencja zapytań po stronie Google',
            },
            en: {
                name: 'Google reverse geocoding',
                description: "When you point at a location on the map or search a city, the geographic coordinates are sent to Google's geocoding API to resolve them into a postal address. The result is not persisted locally.",
                retention: 'not stored locally; request retention is Google-side',
            },
        },
    },
    {
        id: 'googleAnalytics',
        elements: ['gtag.js', '_ga', '_ga_*'],
        category: 'analytics',
        retention: 'third-party',
        descriptions: {
            pl: {
                name: 'Statystyki Google Analytics',
                description: 'Ładuje skrypt Google Analytics (gtag.js), który zbiera anonimowe informacje o sposobie korzystania z aplikacji (odwiedzane strony, urządzenie, przybliżona lokalizacja) i wysyła je do Google. Pomaga nam to mierzyć ruch i ulepszać aplikację. Google może zapisywać własne pliki cookie (np. _ga) w swoich domenach.',
                retention: 'nie przechowujemy danych lokalnie poza plikami cookie ustawianymi przez Google; retencja po stronie Google zgodnie z polityką prywatności Google',
            },
            en: {
                name: 'Google Analytics statistics',
                description: 'Loads the Google Analytics script (gtag.js), which collects anonymous information about how the app is used (pages visited, device, approximate location) and sends it to Google. This helps us measure traffic and improve the app. Google may set its own cookies (e.g. _ga) on Google domains.',
                retention: "not stored locally beyond cookies set by Google; Google-side retention follows Google's privacy policy",
            },
        },
    },
    {
        id: 'privacyConsent',
        elements: ['usePrivacyConsentStore', 'privacy-consent-storage'],
        category: 'necessary',
        retention: 'indefinite',
        descriptions: {
            pl: {
                name: 'Ustawienia prywatności',
                description: 'Zapamiętuje Twoje decyzje dotyczące zgody na poszczególne kategorie usług (niezbędne, funkcjonalne, analityczne), aby nie pytać o nie ponownie przy każdej wizycie. Jest to niezbędne do honorowania Twoich wyborów.',
                retention: 'bez terminu (do zmiany decyzji lub wyczyszczenia danych przeglądarki)',
            },
            en: {
                name: 'Privacy preferences',
                description: 'Remembers your consent decisions for each service category (necessary, functional, analytics) so you are not asked again on every visit. Required in order to honour your choices.',
                retention: 'indefinite (until you change your decision or clear browser data)',
            },
        },
    },
    {
        id: 'bugTracking',
        elements: ['@sentry/react replayIntegration'],
        category: 'analytics',
        retention: 'per-session',
        descriptions: {
            pl: {
                name: 'Diagnostyka błędów (Sentry Session Replay)',
                description: 'W razie wystąpienia błędu nagrywany jest krótki fragment aktywności w przeglądarce (kliknięcia, nawigacja, komunikaty z konsoli) i wysyłany do usługi Sentry, aby pomóc nam zdiagnozować problem. Nagranie żyje wyłącznie w pamięci przeglądarki podczas bieżącej sesji i tylko wtedy, gdy faktycznie wystąpi błąd.',
                retention: 'do zamknięcia karty (tylko w razie wystąpienia błędu)',
            },
            en: {
                name: 'Error diagnostics (Sentry Session Replay)',
                description: 'When an error occurs, a short buffer of your browser activity (clicks, navigation, console messages) is captured and sent to Sentry so the issue can be diagnosed. The buffer lives only in browser memory during the current session and only if an error actually happens.',
                retention: 'until the tab is closed (only upon errors)',
            },
        },
    },
    // { // turned off as dev-only feature
    //   id: 'devFeatureFlagOverrides',
    //   elements: ['__dev_feature_flag_overrides'],
    //   category: 'functional',
    //   retention: 'session',
    //   descriptions: {
    //     pl: {
    //       name: 'Nadpisania flag funkcjonalności (tryb deweloperski)',
    //       description:
    //         'Wyłącznie w trybie deweloperskim: umożliwia programistom tymczasowe nadpisanie wartości flag funkcjonalności z panelu testowego. Nie dotyczy środowiska produkcyjnego.',
    //       retention: 'do zamknięcia karty (tylko tryb deweloperski)',
    //     },
    //     en: {
    //       name: 'Feature-flag overrides (developer mode)',
    //       description:
    //         'Developer-mode only: lets engineers temporarily override feature-flag values from an internal test panel. Not used in production.',
    //       retention: 'until the tab is closed (developer mode only)',
    //     },
    //   },
    // },
];
